import React from 'react';
import LinkField from '../../../../shared/uibuilder/show/field/LinkField';
import UpdateStandardTaskForm from './Standard/UpdateStandardTaskForm';
import UpdateEmailTaskForm from './Email/UpdateEmailTaskForm';

import styles from './OpenUpdateFormField.module.scss';
import UpdateSmsTaskForm from './Sms/UpdateSmsTaskForm';
import useTasksNavigator from '../tasksNavigator';
import { usePopupFormManager } from 'features/nekst-widgets';
import { AbstractTask, EmailTask, EventTask, SmsTask, TaskStatus, TaskType } from 'nekst-api';
import { AfterSubmitFunc, useShowContext } from 'ui-builder';
import UpdateEventTaskForm from './Event/UpdateEventTaskForm';

export function useOpenUpdateFormHelper() {
  const popupManager = usePopupFormManager();

  const openForm = (task: AbstractTask, afterSubmitFunc?: AfterSubmitFunc) => {

    if (task.type === TaskType.STANDARD) {
      popupManager.openForm(<UpdateStandardTaskForm data={task} afterSubmitFunc={afterSubmitFunc} />);
    } else if (task.type === TaskType.EMAIL) {
      popupManager.openForm(<UpdateEmailTaskForm data={task as EmailTask} afterSubmitFunc={afterSubmitFunc} />);
    } else if (task.type === TaskType.SMS) {
      popupManager.openForm(<UpdateSmsTaskForm data={task as SmsTask} afterSubmitFunc={afterSubmitFunc}  />);
    } else if (task.type === TaskType.EVENT) {
      popupManager.openForm(<UpdateEventTaskForm data={task as EventTask} afterSubmitFunc={afterSubmitFunc} />);
    }
  };

  return {
    openForm,
  };
}

export default function OpenUpdateFormField() {
  const showContext = useShowContext<AbstractTask>();
  const data = showContext?.data;

  const className = data?.status === TaskStatus.COMPLETED
    ? styles.completed
    : undefined;

  const tasksNavigator = useTasksNavigator();

  if (data) {
    return (
      <LinkField
        source="_renderedName"
        onClick={() => tasksNavigator.openTask(data!.id)}
        uri={tasksNavigator.getOpenTaskUri(data!.id)}
        className={className}
      />
    );
  } else {
    return null;
  }

}
